// extracted by mini-css-extract-plugin
export default {"wrapper":"FranchiseTableControls_wrapper__sVApI","controls":"FranchiseTableControls_controls__0re7v","clearButton":"FranchiseTableControls_clearButton__EfEgX"};